// extracted by mini-css-extract-plugin
export default {"reportHeaderField":"reportHeaderField-SN62l","value":"value-sn33v","title":"title-UgA3v"};